import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'

export const Layout: FC<LayoutProps> = ({ children, className }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <main id='main' className={cn('flex-1', className)}>
                {children}
            </main>
        </div>
    )
}
